:host {
  display: block;
  padding: 0 16px;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  background: #ffffff;
  background: var(--pes-collapsible-container-bgcolor, #ffffff);
}

@media screen and (max-width: 979px) {
  :host {
    box-shadow: 0 0 2px 0 rgba(51, 51, 51, 0.05), 0 2px 5px 0 rgba(51, 51, 51, 0.15);
    padding: 0 16px;
    background: #ffffff;
  }
}

:host(.collapsed) .content {
  display: none;
}

@media screen and (min-width: 980px) {
  :host(.collapsed) .content {
    display: block;
  }
}

.content {
  padding-bottom: 28px;
}

@media screen and (min-width: 980px) {
  .content {
    padding-bottom: 25px;
  }
}

.collapse-toggle {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  max-width: 36px;
  -webkit-tap-highlight-color: transparent;
}

@media screen and (min-width: 980px) {
  .collapse-toggle {
    display: none;
  }
}

.collapse-toggle--color-default {
  color: #3dcd58;
}

.collapse-toggle--color-inherit {
  color: inherit;
}

.header {
  display: flex;
  flex-direction: row;
}

.header .heading {
  flex: 1 1;
}

@media screen and (min-width: 980px) {
  .header {
    padding-top: 5px;
  }
}

@media screen and (max-width: 979px) {
  .header ::slotted(h2) {
    margin: 20px 0;
  }
}